import { IMessageHandler } from "../message-handler";
import { IHandlerContext } from "../handler-context";
import { StorageMessage, StorageResponse } from "../../crypto/crypto-types";

interface RegisterRequest {
  username: string;
  password: string;
}

interface RegisterResponse {
  success: boolean;
  userId: string;
  username: string;
}

export class RegisterHandler implements IMessageHandler<RegisterRequest> {
  constructor(private context: IHandlerContext) {}

  canHandle(type: string): boolean {
    return type === "REGISTER";
  }

  async handle(message: StorageMessage<RegisterRequest>, source: Window, origin: string): Promise<void> {
    const { username, password } = message.data;

    if (!username || !password) {
      this.context.sendError(source, 'Username and password required', 'MISSING_CREDENTIALS', origin, message.requestId);
      return;
    }

    // Check if user already exists
    const existingUser = await this.context.dbService.getUserByUsername(username);
    if (existingUser) {
      this.context.sendError(source, 'Username already exists', 'USER_EXISTS', origin, message.requestId);
      return;
    }

    // Create new user profile
    const userProfile = await this.context.cryptoEngine.createUserProfile(username, password);
    await this.context.dbService.storeUser(userProfile);

    const response: StorageResponse<RegisterResponse> = {
      type: 'RESPONSE',
      data: {
        success: true,
        userId: userProfile.id,
        username: userProfile.username
      },
      requestId: message.requestId
    };
    this.context.sendResponse(source, response, origin, message.requestId);
  }
}
